<template>
  <section class="upload">
    <div
      class="upload-drag"
      tag="ul"
      draggable=".upload-drag-item"
      chosen-class="chosen"
      force-fallback="true"
      group="people"
      animation="1000"
      @start="handleStart"
      @end="handleEnd"
    >
      <li
        v-for="(item, index) in list"
        :key="item + index"
        class="upload-drag-item"
        :style="{ width: width + 'px', height: height + 'px' }"
      >
        <!-- {{ item.url }} -->
        <el-image
          v-if="type == 'img'"
          :src="item.url"
          :preview-src-list="previewList"
          :z-index="999"
        />
        <video
          v-else-if="type == 'video'"
          :src="item.url"
          controls
          width="720"
          height="405"
        />
        <div v-if="isDelete" class="del" @click="handleDel(item, index)">
          <i class="el-icon-delete" />
        </div>
      </li>
      <item-img
        v-if="type == 'img'"
        slot="footer"
        v-model="list"
        :is-delete="isDelete"
        :action="action"
        :limit="limit"
        :width="width"
        :size="5120"
        :height="height"
        @add="handleAdd"
      />
      <item-video
        v-else-if="type == 'video'"
        slot="footer"
        v-model="list"
        :is-delete="isDelete"
        :action="action"
        :limit="limit"
        :width="width"
        :height="height"
        @add="handleAdd"
      />
      <item-file
        v-else
        slot="footer"
        v-model="list"
        :is-delete="isDelete"
        :action="action"
        :limit="limit"
        :width="width"
        :height="height"
        @add="handleAdd"
      />
    </div>
  </section>
</template>

<script>
import vuedraggable from 'vuedraggable'
import comVideo from '@/components/system/comVideo'
import itemImg from './item/img.vue'
import itemVideo from './item/video.vue'
import itemFile from './item/file.vue'
export default {
  name: 'ComUpload',
  components: { vuedraggable, comVideo, itemImg, itemVideo, itemFile },
  props: {
    type: {
      type: String,
      default: 'img' // img|video|file
    },
    typeStr: {
      type: String,
      default: '图片' // 图片|视频|文件
    },
    // imgs
    value: {
      type: Array,
      default() {
        return []
      }
    },
    width: {
      type: Number,
      default: 100
    },
    height: {
      type: Number,
      default: 100
    },
    isDelete: {
      type: Boolean,
      default: true
    },
    // upload
    action: {
      type: String,
      default: '/api/FileUpload/DebtAudit'
    },
    // 限制上传的图片数量(单图上传就是已传图片和上传按钮重叠)
    limit: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {}
  },
  computed: {
    list: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    previewList() {
      return this.list.map((item, index) => {
        return item.url
      })
    }
  },
  watch: {},
  mounted() {},
  methods: {
    // 拖拽元素
    handleStart(e) {
      e.target.classList.add('hideShadow')
    },
    handleEnd(e) {
      e.target.classList.remove('hideShadow')
    },
    // 添加单张图片
    handleAdd(e) {
      this.$emit('add', e)
    },
    // 移除单张图片
    handleDel(item, index) {
      this.$confirm('确定删除该图片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // const l = _this.list.filter((v, i) => {
          //   return i !== index
          // })
          // _this.list = l
          this.list.splice(index, 1)
          this.$emit('del', item)
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
.upload {
  &-drag {
    display: flex;
    flex-wrap: wrap;
    padding: 0px;
    &-item {
      margin-right: 15px;
      margin-bottom: 15px;
      @include fun-border(1);
      border-radius: 6px;
        position: relative;
      overflow: hidden;
      .del {
        width: 40px;
        height: 40px;
        position: absolute;
        top: 2%;
        right: 10%;
        transform: translate(50%);
        background-color: rgba(0, 0, 0, 0.4);
        opacity: 0;
        transition: opacity 0.3s;
        color: #fff;
        font-size: 22px;
        line-height: 22px;
        padding: 2px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
      &:hover {
        .del {
          opacity: 1;
        }
      }
    }
    &.hideShadow {
      .del {
        display: none;
      }
    }
  }
}
.upload /deep/ .el-image__preview{

    object-fit:cover

}
</style>
